<script setup>
import { onMounted } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useRequestsStore } from '@/stores/storeRequests';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BaseInput from '@/components/ui/BaseInput.vue';

const storeSert = useSertStore();
const storeRequests = useRequestsStore();

const nextSreen = async () => {
    const response = await storeRequests.authorizationConfirm();
    if(!response?.success) return;
    if(storeRequests.userData?.is_full_profile){
        storeSert.goToScreen(storeSert.screens.design)
        history.pushState(null, "", `#${storeSert.screens.design}`)
    } else {
        storeSert.goToScreen(storeSert.screens.authUserData)
        history.pushState(null, "", `#${storeSert.screens.authUserData}`)
    }    
};

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.authPhone)
    history.pushState(null, "", `#${storeSert.screens.authPhone}`)
    storeRequests.responseError = null
    storeSert.resetTimer()
}

const resetFields = () => {
    storeSert.updateCheckedItem('phone', 'title', '')
    storeSert.updateCheckedItem('phone', 'disabledBtn', false)
    storeSert.updateCheckedItem('rules', 'title', '')
    storeSert.updateCheckedItem('rules', 'disabledBtn', false)
}

const repeatAuth = async () => {
    await storeRequests.authorization()
    storeSert.timer()
    storeSert.updateCheckedItem('confirmationCode', 'title', null)
}

onMounted(() => {
    
})

</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="2">
                <template #title>авторизация</template>
                <template #text>Мы отправили SMS с кодом активации на указанный вами номер {{ storeSert.fields.phone.title }}</template>
            </SertHeader>            
            <div class="form --form-pay">                
                <div :class="['form__row ', ]">
                    <div class="form__row-inner">
                        <BaseInput 
                            type="number" 
                            placeholder="Введите код"
                            state-key="confirmationCode"   
                            :required="true"  
                        >
                            Код
                        </BaseInput>
                        
                        <Transition>
                            <div :class="['form__timer']">
                                <button :disabled="storeSert.timerActive" @click="repeatAuth()">
                                    Отправить код ещё раз
                                    <span v-if="storeSert.timerActive">
                                        {{ storeSert.remainingTime.minutes }}:{{ storeSert.remainingTime.secundes }}
                                    </span> 
                                </button>
                            </div>
                        </Transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="constructor__btns-inner">
            <p class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
            <div class="constructor__btns">
                <button class="btn --black" @click="previousSreen">
                    <span>Назад</span>
                </button>
                <button :disabled="storeSert.isBtnDisabled(['confirmationCode'])" class="btn --full" @click="nextSreen">
                    <span v-if="!storeRequests.loaderBtn">Подтвердить</span>
                    <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                </button>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>